/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { clip, mj_extract_location_hash } from './util.js';
import { jQuery } from '../other/jquery-hooked.js';


export let MVPageHistory = function($) {

	var mj_replace_hash, mj_replace_hash_trigger;
	var mj_push_hash, mj_push_hash_trigger;

	var _hash_history = [];			// [window.location.hash],
	var _hash_history_length = 0;	//window.history.length;
	var _prev_history_hashes = [];
	var _last_triggered_hash_change = null;


	function mj_url_from_hash(hash) {
		var url = document.location.href;
		if( url.indexOf('#')!=-1 ) url = url.substr( 0, url.indexOf('#') );
		return url + hash;
	}

	function init( window ) {
		// console.log(['MVPageHistory.init()']);

		if( 'replaceState' in window.history ) {
			mj_replace_hash = function(state,newhash) {
				if( (''+newhash).charAt(0) !== '#' ) newhash = '#' + newhash;
				history.replaceState(state,'',mj_url_from_hash(newhash));
			};
			mj_replace_hash_trigger = function(state,newhash) {
				if( (''+newhash).charAt(0) !== '#' ) newhash = '#' + newhash;
				history.replaceState(state,'',mj_url_from_hash(newhash));
				$(window).trigger('hashchange');
			};
		} else {
			var first_hash = location.hash;
			mj_replace_hash = function(state,newhash) {
				if( location.hash !== first_hash ) history.back();
				location.hash = newhash;
			};
			mj_replace_hash_trigger = function(state,newhash) {
				if( location.hash !== first_hash ) history.back();
				location.hash = newhash;
			};
		}

		if( 'pushState' in window.history ) {
			mj_push_hash = function(state,newhash) {
				if( (''+newhash).charAt(0) !== '#' ) newhash = '#' + newhash;
				history.pushState(state,'',mj_url_from_hash(newhash));
			};
			mj_push_hash_trigger = function(state,newhash) {
				mj_push_hash(state,newhash);
				$(window).trigger('hashchange');
			};
		} else {
			mj_push_hash = function(state,newhash) {
				// we can't yet avoid triggering here ...
				document.location.hash = newhash;
			};
			mj_push_hash_trigger = function(state,newhash) {
				document.location.hash = newhash;
			};
		}

		$(window).on( 'hashchange', mj_on_hashchange );
		$(window).on( 'popstate', mj_on_popstate );
	}


	function mj_on_hashchange( evt ) {
		// console.log(['MVPageHistory.mj_on_hashchange()',e]);
		var cur_hash = window.location.hash;
		var cur_length = window.history.length;
		var history_delta = 0;
		if( _hash_history.length && _hash_history_length===cur_length ) {
			if( _hash_history[_hash_history.length-2] == cur_hash ) {
				_hash_history.pop();
				history_delta = -1;
			} else {
				_hash_history.push(cur_hash);
				history_delta = 1;
			}
		} else {
			_hash_history.push(cur_hash);
			_hash_history_length = cur_length;
		}
		_prev_history_hashes.push(cur_hash);
		if( _prev_history_hashes.length>10 ) _prev_history_hashes = _prev_history_hashes.slice(-10);
		//console.log(['hashchange',e,cur_hash,_prev_history_hashes,history_delta, '_hash_history_length='+_hash_history_length, 'window.history.length='+window.history.length, '_hash_history=',_hash_history, 'window.history=',window.history ]);
		mj_trigger_hashchange( cur_hash, history_delta, evt );
	}

	function mj_on_popstate( e ) {
		//console.log(['popstate',e,window.history.state,_prev_history_hashes ]);
	}

	function mj_trigger_hashchange( h, history_delta, evt ) {
		var x = mj_extract_location_hash(h);
		// console.log(['MVPageHistory.mj_trigger_hashchange()',h,history_delta,evt,x,document]);
		if( x[0]!==null ) {
			if( _last_triggered_hash_change===null || (x[2]!='0'&&x[2]!=''&&x[2]!=null) || !( _last_triggered_hash_change!==null&&_last_triggered_hash_change[0]===x[0]&&_last_triggered_hash_change[1]===x[1] ) ) {
				_last_triggered_hash_change = x;
				$(document).triggerHandler('mjshashchange',[x[0],x[1],x[2],history_delta||0]);
			}
		} else if( _last_triggered_hash_change===null || ( h!='#0' && h!='#0&' ) ) {
			_last_triggered_hash_change = x;
			$(document).triggerHandler('mjshashchange',[x[0],x[1],x[2],history_delta||0]);
		}
	}

	function get_trigger_method( trigger_mode ) {
		switch( trigger_mode ) {
		case 'replace':			return mj_replace_hash;
		case 'replacetrigger':	return mj_replace_hash_trigger;
		case 'pushonly':		return mj_push_hash;
		case 'suppress':		return mj_push_hash_trigger;//mj_push_hash;
		default:				return mj_push_hash_trigger;
		}
	}

	/**
	 *
	 * @param {number} idx 		0 -> current hash, -1 -> previous hash
	 */
	function getHistoryHash( idx ) {
		if( idx<0 ) {
			idx = clip(_prev_history_hashes.length-1-idx,0,_prev_history_hashes.length-2);
			return _prev_history_hashes[idx];
		}
		return window.location.hash;
	}

	// alter location hash ("#key=value") & trigger a change event
	function go( k, v, trigger_mode ) {
		// console.log(['MVPageHistory.go()',k,v,trigger_mode]);
		// note: altering document.location.hash will trigger a "hashchange" event on window,
		//  which - as a result - will trigger an "mjshashchange" event on document
		var hash = '';
		var state = {};
		if( k===null || k==='' ) {
			hash = trigger_mode==='suppress' ? '#0' : '';
		} else {
			state[k] = v;
			var t = typeof v;
			if( t!=='string' && t!=='number' && t!=='boolean' ) v = JSON.stringify(v);
			var hc_ctrl_pfx = '';
			if( trigger_mode==='force' ) {
				hc_ctrl_pfx = Date.now()+'&';
			} else if( trigger_mode==='suppress' ) {
				hc_ctrl_pfx = '0&';
				// suppress action when location would not change...
				var x = mj_extract_location_hash(document.location.hash);
				//if( x[0]!==null && x[0]===k ) console.log(['MVPageHistory.go - suppressing?',x[1]===v,x[1],v]);
				if( x[0]!==null && x[0]===k && x[1]===v ) return;
			}
			hash = '#'+hc_ctrl_pfx+k+'='+encodeURIComponent(v);
		}
		try {
			var method = get_trigger_method(trigger_mode);
			// console.log(['MVPageHistory.go()',k,v,trigger_mode,method,state,hash]);
			method(state,hash);
		} catch( err ) {
			// an exception thrown here probably means a limit on location hash size (IE)...
			// instead: trigger mjshashchange directly:
			if( trigger_mode!=='replace' ) mj_trigger_hashchange(hash);
		}
	}

	return {
		init: init,
		getHistoryHash: getHistoryHash,
		go: go,
	};

}(jQuery); // namespace MVPageHistory


// here to break dependency with page-util.js...
window.MVPageHistory = MVPageHistory;
